import * as yup from "yup";
import { TerminalFormValues } from "./types";

export const defaultFormValues: TerminalFormValues = {
  id: undefined,
  name: "",
  invoiceSequence: 1,
  saleSufix: "",
  salePrefix: "",
  paymentMethodIds: [],
  enabled: true,
};

export const schema = yup.object().shape({
  id: yup.string().nullable().optional(), // or yup.mixed() if it could be other than string
  name: yup.string().required("Name is required"),
  invoiceSequence: yup
    .number()
    .min(1, "Invoice sequence must be at least 1")
    .required("Invoice sequence is required"),
  saleSufix: yup.string().optional(),
  salePrefix: yup.string().optional(),
  paymentMethodIds: yup.array().of(yup.string()).optional(),
  enabled: yup.boolean().required(),
});
